import React, { FC } from 'react';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import * as PropTypes from 'prop-types';
import { variant } from 'styled-system';

import { Box } from '..';
import { StickyBoxProps } from './types';
// TODO: implements onStuck onUnstuck events
// https://developers.google.com/web/updates/2017/09/sticky-headers
const StyledStickyBox = styled(Box, {
  shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'to',
})<StickyBoxProps>(
  css({
    position: 'sticky',
    zIndex: 'stickyBox',
  }),
  variant({
    prop: 'to',
    variants: {
      top: {
        top: '0px',
      },
      bottom: {
        bottom: '0px',
      },
    },
  })
);

const StickyBox = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof StyledStickyBox>
>(({ to = 'top', ...props }, ref) => (
  <StyledStickyBox to={to} {...props} ref={ref} />
));

StickyBox.propTypes = {
  to: PropTypes.oneOf(['bottom', 'top']),
};

export default StickyBox;
